import { Box, Card, Skeleton, Typography } from "@mui/material";
import { ReactNode } from "react";

interface KpiCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  iconBgColor: string;
  cardBgColor: string;
  valueColor: string;
  caption?: string;
  trend?: string; // e.g. "+5% from last week"
  isLoading?: boolean;
}

const WSKpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  icon,
  iconBgColor,
  cardBgColor,
  valueColor,
  caption = title,
  trend = "+5% from last week",
  isLoading = false
}) => {
  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 4,
        bgcolor: cardBgColor,
        boxShadow: 1,
        textAlign: "center"
      }}
    >
      <Box
        sx={{
          bgcolor: iconBgColor,
          width: 40,
          height: 37,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2
        }}
      >
        {icon}
      </Box>

      {isLoading ? (
        <>
          <Skeleton width="60%" height={28} sx={{ mx: "auto", mb: 1 }} />
          <Skeleton width="40%" height={18} sx={{ mx: "auto" }} />
        </>
      ) : (
        <>
          <Typography variant="h6" fontWeight={600} color={valueColor}>
            {value}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {caption}
          </Typography>
          {/* {trend && (
            <Typography variant="body2" color="success.main" mt={1}>
              {trend}
            </Typography>
          )} */}

          <Typography variant="body2" color="success.main" mt={1}>
            {trend}
          </Typography>
        </>
      )}
    </Card>
  );
};

export default WSKpiCard;
